export default __webpack_public_path__ + "static/media/meIJ.aa3efbe7.jpg";